import React from 'react';

import { ArrowRightIcon } from 'components/Icons';

import NavigationButton, { NavigationButtonProps } from './NavigationButton';

import styles from './Button.module.scss';

const NextButton = ({ link, children, ...restProps }: React.PropsWithChildren<NavigationButtonProps>) => {
  return (
    <NavigationButton {...restProps} link={link} className={styles.button_next}>
      {children}
      <ArrowRightIcon className={styles.arrow_right} width={16} height={12} />
    </NavigationButton>
  );
};

export default NextButton;
